module.exports = __webpack_public_path__ + "img/Add-monitor-short.6b5ce798.svg";